import React from "react";
// local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {Modal} from "components/Modal";
import {VideoInstruction} from "components/VideoInstruction";

export const ModalAbout = ({onClick}) => {
  return (
    <Modal
      titleIcon={null}
      titleText="APP_START_PAGE_HEADER"
      suffixTitleIcon=" 🎉"
      hugeTitle
      noCloseOnEsc
      width={680}
      rounded
      onClick={onClick}
    >
      <div className="pa-5 df-column-center">
        <VideoInstruction
          url="https://player.vimeo.com/video/657058643?h=a5e5d1834d"
          size={{width: "640", height: "360"}}
          allowFullScreen
        />
        <ButtonTransparent
          onClick={onClick}
          addClass="mt-8 mb-4"
          name="DONE"
          medium
          nonTransparent
        />
      </div>
    </Modal>
  );
};
